export default "__VITE_ASSET__CevgbhHi__"